const MODULE_NAME = 'shared/'

//define actions name
const A_LOADING = 'loading'
const A_UNLOADING = 'unloading'
const A_DIALOG = 'openDialog'
const A_CLOSE_DIALOG = 'closeDialog'

//define dispatch action
export const SHARED_LOADING = MODULE_NAME + A_LOADING
export const SHARED_UNLOADING = MODULE_NAME + A_UNLOADING
/* SHARED DIALOG IS NOT INUSE */
export const SHARED_DIALOG = MODULE_NAME + A_DIALOG
export const SHARED_CLOSE_DIALOG = MODULE_NAME + A_CLOSE_DIALOG

//define mutations name
const M_LOADING = 'loading'
const M_UNLOADING = 'unloading'
const M_DIALOG = 'openDialog'
const M_CLOSE_DIALOG = 'closeDialog'

const state = {
  isLoading: null,
  isShowDialog: null,
  dialog: {
    title: '',
    messages: [],
    mainButtonTitle: '',
    isSecondaryButtonShow: false,
    secondaryButtonTitle: ''
  }
}

//to retrieve data from store state (called by component)
const getters = {}

//to perform some actions related with updating state (called by component)
const actions = {
  [A_LOADING]({ commit }, options) {
    commit(M_LOADING, options)
  },
  [A_UNLOADING]({ commit }, options) {
    commit(M_UNLOADING, options)
  },
  [A_DIALOG]({ commit }, { dialogTitle, dialogMessages, dialogMainButtonTitle, dialogIsSecondaryButtonShow, dialogSecondaryButtonTitle }) {
    commit(M_DIALOG, { dialogTitle, dialogMessages, dialogMainButtonTitle, dialogIsSecondaryButtonShow, dialogSecondaryButtonTitle })
  },
  [A_CLOSE_DIALOG]({ commit }) {
    commit(M_CLOSE_DIALOG)
  }
}

let unloadingTimer = null
let dismissKey = null
let lockDismissUntil = null
let safetyTimer = null
function handleShowLoadingOptions(state, options) {
  if (options) {
    // Requested to not dismiss, cancel the timer of previous action
    if (options.cancelUnloadingTimer && unloadingTimer) {
      clearTimeout(unloadingTimer)
      unloadingTimer = null
    }

    // Requested that future action to not dismiss this, set a
    // simple lock so that loading indicator can only be dismissed by matching lock
    if (options.lockDismiss && options.dismissKey) {
      dismissKey = options.dismissKey

      // Lock for max up to then given duration
      lockDismissUntil = options.lockDismiss * 1000

      // Safety timer as precaution to prevent stuck forever if caller do not dismiss manually
      if (safetyTimer) {
        clearTimeout(safetyTimer)
      }
      safetyTimer = setTimeout(() => {
        state.isLoading = false
        safetyTimer = null
        dismissKey = null
      }, lockDismissUntil)
    }
  }
}

//to update state values (called by actions)
const mutations = {
  [M_LOADING](state, options) {
    state.isLoading = true
    handleShowLoadingOptions(state, options)
  },
  [M_UNLOADING](state, options) {

    // Has a timer lock
    if (dismissKey) {
      if (!(options && options.dismissKey && options.dismissKey === dismissKey)) {
        return
      }
    }
    if (options && options.dismissKey && (!dismissKey || options.dismissKey !== dismissKey)) {
      // Want to dismiss for a specific lock, but lock change, abort
      return
    }

    // Clear old timer before set new timer, else will multiple dismiss and mess up
    // when want to show loading
    if (unloadingTimer) {
      clearTimeout(unloadingTimer)
      unloadingTimer = null
    }

    unloadingTimer = setTimeout(function() {
      state.isLoading = false
      dismissKey = null
      unloadingTimer = null

      if (safetyTimer) {
        clearTimeout(safetyTimer)
        safetyTimer = null
      }
    }, 300)
  },
  [M_DIALOG](state, { dialogTitle, dialogMessages, dialogMainButtonTitle, dialogIsSecondaryButtonShow, dialogSecondaryButtonTitle }) {
    state.dialog.title = dialogTitle
    state.dialog.messages = dialogMessages
    state.dialog.mainButtonTitle = dialogMainButtonTitle
    state.dialog.isSecondaryButtonShow = dialogIsSecondaryButtonShow
    state.dialog.secondaryButtonTitle = dialogSecondaryButtonTitle
    state.isShowDialog = true
  },
  [M_CLOSE_DIALOG]() {
    state.dialog.title = ''
    state.dialog.messages = []
    state.dialog.mainButtonTitle = ''
    state.dialog.isSecondaryButtonShow = false
    state.dialog.secondaryButtonTitle = ''
    state.isShowDialog = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
